<app-lista-dados
  [upTitulo]="'Abastecimentos'"
  [upIcone]="'local_gas_station'"
  [upDados]="dados"
  [upColunas]="colunas"
  [upHabilitaContador]="true"
  [upHabilitaFiltroRapido]="true"
  [upFiltroRapido]="filtrarLinha"
  [upHabilitaEditarLinha]="true"
  [upCarregando]="!!subscription"
  [upAcoesLinha]="acoesLinha"
  (ueAcaoLinha)="onEditarObservacao($event.linha)"
  (ueMudouValorLinha)="onMudouValorLinha($event)"
  (ueIniciarEdicaoLinha)="onIniciarEdicaoLinha($event)"
  (ueSalvarLinha)="onSalvarLinha($event)"
  (ueBotaoExcluir)="onDelete($event)">
</app-lista-dados>
